import { render, staticRenderFns } from "./DeCanvas.vue?vue&type=template&id=0704bc30&"
import script from "./DeCanvas.vue?vue&type=script&lang=js&"
export * from "./DeCanvas.vue?vue&type=script&lang=js&"
import style0 from "./DeCanvas.vue?vue&type=style&index=0&id=0704bc30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports